import { useEffect, useState } from 'react'
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'
import styled from 'styled-components'
import BrandSelection from 'BrandSelection'

import { useAppDispatch } from '../store/hooks'
import { setBrandTheme } from '../store/reducer/ui'
import { brands } from './utils/constant'

import Homepage from './page/homepage/Homepage'
import Details from './page/detail/Details'

import Header from './component/shared/header/Header'
import Footer from './component/shared/footer/Footer'

const Main = styled.div`
    margin: 48px 0;
`

export function App() {
    const [router, setRouter] = useState<ReturnType<typeof createBrowserRouter> | null>(null)
    const [showBrandSelection, setShowBrandSelection] = useState(false)
    const dispatch = useAppDispatch()

    useEffect(() => {
        const supportedBrands = [brands.CIAT, brands.CARRIER, brands.VIESSMANN]
        const currentBrand = supportedBrands.find((brand) => location.pathname.includes(`/${brand}`))

        // Show brand selection when no brand is selected
        if (!currentBrand) {
            setShowBrandSelection(true)
            return
        }

        const basename = `/${currentBrand}`

        // Set the brand theme in Redux
        dispatch(setBrandTheme(currentBrand as any))

        const Layout = () => (
            <div>
                <Header />
                <Main>
                    <Outlet />
                </Main>
                <Footer />
            </div>
        )

        setRouter(
            createBrowserRouter(
                [
                    {
                        path: '/',
                        element: <Layout />,
                        children: [
                            {
                                index: true,
                                element: <Homepage />,
                            },
                            {
                                path: 'model/:selectedModel',
                                element: <Details />,
                            },
                        ],
                    },
                ],
                {
                    basename,
                }
            )
        )
    }, [])

    if (showBrandSelection) {
        return <BrandSelection />
    }

    return <>{router && <RouterProvider {...{ router }} />}</>
}
